import React from 'react';
import { Col } from 'react-bootstrap';
import { Button } from '../../../../../common/components';
import QuoteSavePolicy from '../../QuoteSavePolicy/QuoteSavePolicy';
import QuoteSaveAndSendPolicy from '../../QuoteSaveAndSendPolicy/QuoteSaveAndSendPolicy';

const QuoteActions = ({
  showSave,
  showEmail,
  showNext,
  isSaving,
  saveAndExit,
  saveEmailAndExit,
  goToNextPage,
}) => {
  return (
    <Col xs={12} className="bottom-bar">
      <div className="save-quote-btn-sidebar" id="save-quote-btn-sidebar">
        <QuoteSavePolicy isSaving={isSaving} saveAndExit={saveAndExit} show={showSave} />
        <QuoteSaveAndSendPolicy
          isSaving={isSaving}
          saveAndExit={saveEmailAndExit}
          show={showEmail}
        />
        {showNext && (
          <Button
            label="Next"
            className="btn-primary"
            bsStyle="primary"
            block
            rightIcon="caret-right"
            handleClick={goToNextPage}
          />
        )}
      </div>
    </Col>
  );
};

export default QuoteActions;
